module.exports = __webpack_public_path__ + "static/lohnbuchhaltung-personalstamm-de-17a0785d50f6065d84535a2d1c2958e9.png";